var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRef, useState } from '@max/max';
import { API_PATH, RequestStatus, useRequest } from './useRequest';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export function useRankingList(options) {
    const ctx = useMonitorEngineContext();
    const [rankingList, setRankingList] = useState([]);
    const pageNo = useRef(1);
    const [hasMore, setHasMore] = useState(true);
    const [status, setStatus] = useState(RequestStatus.SUCCESS);
    const { request } = useRequest(API_PATH.RANKING_LIST);
    function loadRankingList(pageNo = 1, isLoadMore = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (isLoadMore) {
                    setStatus(RequestStatus.LOADING_MORE);
                }
                else {
                    setStatus(RequestStatus.LOADING);
                }
                const res = yield request({
                    activityId: options.activityId,
                    taskId: options.taskId,
                    pageNo,
                    pageSize: options.pageSize || 10
                });
                if (res) {
                    const { topTeamList, hasNextPage = false } = res.extra || {};
                    if (!Array.isArray(topTeamList)) {
                        setRankingList([]);
                        setStatus(RequestStatus.SUCCESS);
                        return;
                    }
                    if (topTeamList.length === 0) {
                        (_b = (_a = ctx._raptorReport).monitorReportShelfEmpty) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            apiPath: API_PATH.RANKING_LIST
                        });
                    }
                    else {
                        (_d = (_c = ctx._raptorReport).monitorReportShelfNormal) === null || _d === void 0 ? void 0 : _d.call(_c, {
                            apiPath: API_PATH.RANKING_LIST
                        });
                    }
                    if (isLoadMore) {
                        // 加载更多，追加数据
                        setRankingList(prev => [...prev, ...topTeamList]);
                        setStatus(RequestStatus.LOADING_MORE_SUCCESS);
                    }
                    else {
                        // 初始加载或刷新，替换数据
                        setRankingList(topTeamList);
                        setStatus(RequestStatus.SUCCESS);
                    }
                    // 判断是否还有更多数据
                    setHasMore(hasNextPage);
                    (_f = (_e = ctx._raptorReport).monitorReportBizSuccess) === null || _f === void 0 ? void 0 : _f.call(_e, {
                        apiPath: API_PATH.RANKING_LIST
                    });
                }
                else {
                    throw new Error('获取排行榜数据失败');
                }
            }
            catch (err) {
                setStatus(isLoadMore ? RequestStatus.LOADING_MORE_ERROR : RequestStatus.ERROR);
                (_h = (_g = ctx._raptorReport).monitorReportBizFailed) === null || _h === void 0 ? void 0 : _h.call(_g, {
                    apiPath: API_PATH.RANKING_LIST
                });
                ctx._raptorReport.monitorReportLog('获取排行榜数据失败', err, {
                    category: 'ajaxError',
                    level: 'warn'
                });
                ctx._uiInteractionAPI.toast.show({
                    content: '获取排行榜数据失败'
                });
            }
        });
    }
    function loadMore() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!hasMore || status === RequestStatus.LOADING_MORE) {
                return;
            }
            pageNo.current += 1;
            yield loadRankingList(pageNo.current, true);
        });
    }
    function refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            pageNo.current = 1;
            setHasMore(true);
            setRankingList([]);
            yield loadRankingList(pageNo.current, false);
        });
    }
    function initialLoad() {
        return __awaiter(this, void 0, void 0, function* () {
            pageNo.current = 1;
            setRankingList([]);
            yield loadRankingList(pageNo.current, false);
        });
    }
    return {
        rankingList,
        status,
        hasMore,
        loadRankingList: initialLoad,
        loadMore,
        refresh
    };
}
